import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/reseller-services`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/reseller-services/${id}?include=reseller`, options)
    .then((response) => {
      let resellerService = jsona.deserialize(response.data);
      delete resellerService.links;
      return resellerService;
    });
}

function add(resellerService) {
  const payload = jsona.serialize({
    stuff: resellerService,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/reseller-services`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(resellerService) {
  const payload = jsona.serialize({
    stuff: resellerService,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/reseller-services/${resellerService.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/reseller-services/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
